import React from 'react';
import { observer } from 'mobx-react';
import { DateTemplate } from 'themes/components';
import { useStores } from 'core/stores/StoreContext';

const Date = observer((props) => {
    const { localizationStore, timeZoneStore } = useStores();
    return <DateTemplate {...props} language={localizationStore.language} timeZone={timeZoneStore.timeZone} />;
});

export default Date;
